import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./Projects.scss";
import { useTranslation } from "react-i18next";

interface Project {
  title: string;
  description: string;
  link?: string;
}

const Projects: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();

  const projects: Project[] = [
    {
      title: t("projects.checkchecker.title"),
      description: t("projects.checkchecker.description"),
      link: t("projects.checkchecker.link"),
    },
    {
      title: t("projects.ehospoda.title"),
      description: t("projects.ehospoda.description"),
      link: t("projects.ehospoda.link"),
    },
    {
      title: t("projects.turnus.title"),
      description: t("projects.turnus.description"),
      link: t("projects.turnus.link"),
    },
  ];

  return (
    <Container id="projects" className={`py-5 projects ${className}`}>
      <Row>
        <Col>
          <h2 className="projects-title">{t("projects.title")}</h2>
          <Row className="projects-cards">
            {projects.map((project, index) => (
              <Col lg={4} md={6} className="mb-4" key={index}>
                <Card className="project-card h-100">
                  {project.link && (
                    <div className="project-iframe-container">
                      <a
                        href={project.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-iframe-overlay"
                      >
                        <span className="visually-hidden">{project.title}</span>
                      </a>
                      <iframe
                        src={project.link}
                        title={project.title}
                        className="project-iframe"
                        loading="lazy"
                      />
                    </div>
                  )}
                  <Card.Body className="d-flex flex-column">
                    <Card.Title>{project.title}</Card.Title>
                    <Card.Text>{project.description}</Card.Text>
                    {project.link && (
                      <div className="mt-auto">
                        <Button
                          variant="outline-primary"
                          href={project.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t("home.learnMore")}
                        </Button>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default Projects;
